import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {PageRequest} from '../../shared/models/page-request.interface';
import {Observable, throwError} from 'rxjs';
import {Page} from '../../shared/models/page.interface';
import {Master} from '../../admin/models/master.interface';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {ClassifiersSearch} from '../models/classifiers-search.interface';
import {ApiHttpResponse} from '../../shared/models/api-http-response.interface';
import {catchError, map} from 'rxjs/operators';
import {MasterForm} from '../models/master-form';

const API_URL = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class ClassifiersService {

  constructor(private http: HttpClient) { }

  static buildSearchParams(search: ClassifiersSearch): string {
    let searchParams = '';
    if (search.code && search.code !== '') {
      searchParams += `&code=${search.code}`;
    }
    if (search.description && search.description !== '') {
      searchParams += `&description=${search.description}`;
    }
    if (search.status) {
      searchParams += `&status=${search.status}`;
    }
    return searchParams;
  }

  search(classifiersType: string, pageRequest: PageRequest = {page: 0, size: 100}, search?: ClassifiersSearch): Observable<Page<Master>> {
    let url = `${API_URL}${classifiersType}?size=${pageRequest.size}&page=${pageRequest.page}`;
    if (search) {
      url = url + ClassifiersService.buildSearchParams(search);
    }
    if (pageRequest.sort && pageRequest.direction) {
      url = url + `&sort=${pageRequest.sort},${pageRequest.direction}`;
    }
    return this.http.get<Page<Master>>(url);
  }

  create(classifier: MasterForm, classifiersType: string): Observable<ApiHttpResponse<MasterForm>> {
    return this.http.post<ApiHttpResponse<MasterForm>>(`${API_URL}${classifiersType}`, classifier)
      .pipe(
        catchError(err => {
          return throwError(err);
        }),
        map((res: ApiHttpResponse<MasterForm>) => {
          return res;
        })
      );
  }

  update(classifier: MasterForm, classifiersType: string): Observable<ApiHttpResponse<MasterForm>> {
    return this.http.put<ApiHttpResponse<MasterForm>>(`${API_URL}${classifiersType}`, classifier)
      .pipe(
        catchError(err => {
          return throwError(err);
        }),
        map((res: ApiHttpResponse<MasterForm>) => {
          return res;
        })
      );
  }


  delete(id: number, classifiersType: string): Observable<HttpResponse<any>> {
    return this.http.delete(`${API_URL}${classifiersType}/${id}`, {observe: 'response'})
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  }

}
